import BaseModel from '../../base';

export default class EventStatistic extends BaseModel {
  constructor(item, url) {
    super(item, url);

    this.event_id = item.event_id;

    /** {
          24365: {
            "group_id": 24365,
            "group_name": "5-6 класс",
            "nomination_id": 19413,
            "nomination_name": "Экономика",
            "participants_count": 0,
            "tournament_participants_count": 0
          }
        }
     */
    this.groups_breakdown = item.groups_breakdown || {};

    this.groups_count = item.groups_count;
    this.nominations_count = item.nominations_count;
    this.participants_count = item.participants_count;

    this.subordination_event_count = item.subordination_event_count;
    this.subordination_request_count = item.subordination_request_count;

    this.created_at = item.created_at;
    this.updated_at = item.updated_at;
    this.summary_calculated_at = item.summary_calculated_at;
    this.groups_breakdown_built_at = item.groups_breakdown_built_at;
  }
  // get nominations() {
  //   const breakdownGroupsList = Object.values(this.groups_breakdown).map(i => ({

  //   }));
  //   return []
  // }
}
